import {
  useEffect, useMemo, useRef, useState
} from 'react';
import useSWR from 'swr';

import keycloakService from '../../keycloak_service';
import { sinatraOrigin } from '../../config';

const JUPYTER_KEY = 'wallaroo__jupyter';

const fetchFromApi = (sinatraEndpoint = '') => fetch(
  `${sinatraOrigin}/${sinatraEndpoint}`,
  { headers: { Authorization: keycloakService.getAuthHeader() } }
).then(response => response.json())

const useJupyter = () => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { data: jupyter, error } = useSWR('jupyter.json', fetchFromApi)

  const cachedJupyter = useMemo(() => {
    const cachedJupyterString = localStorage.getItem(JUPYTER_KEY);
    if (!cachedJupyterString) {
      return null;
    }
    return JSON.parse(cachedJupyterString);
  }, []);

  useEffect(() => {
    if (jupyter) {
      localStorage.setItem(JUPYTER_KEY, JSON.stringify(jupyter));
    }
  }, [jupyter]);

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    jupyter: jupyter || cachedJupyter,
    error: errorMessage,
  };
};
export default useJupyter;
